import styled from "styled-components";

export const Content = styled.div`
  padding: 30px;
  padding-bottom: 0px;
  margin-top: 100px;
  width: 100%;
  background-color: #f5f5f5;
`;

export const Title = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  margin-bottom: 16px;

  color: rgba(0, 0, 0, 0.87);
`;

export const SpaceY: any = styled.div`
  margin-top: ${(props: any) => props.space}px;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-height: 680px;
`;

export const List = styled.div`
  border-right: 2px solid #f5f5f5;
  width: 40%;
  overflow-y: scroll;
`;

export const VideoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 95%;
  margin: 0 auto;
  height: 64px;
  padding: 16px 32px;
  display: flex;
  border-bottom: 2px solid #f5f5f5;
  transition: all 0.2s ease-in-out;
  border-radius: 8px;
  :hover {
    cursor: pointer;
    background-color: #f5f5f5;
    transform: scale(1.001);
    width: 100%;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    letter-spacing: -0.01em;
    color: #333333;
  }
`;

export const VideoItemSkelleton = styled.div`
  display: flex;
  align-items: center;
  width: 95%;
  margin: 4px auto;
  background-color: #f5f5f5;
  height: 64px;
  padding: 16px 32px;
  display: flex;
  border-bottom: 2px solid #f5f5f5;
  transition: all 0.2s ease-in-out;
  border-radius: 8px;
`;

export const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const VideoTitle = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  border-bottom: 2px solid #f5f5f5;
  padding: 16px;
  width: 100%;
  height: 56px;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.01em;
    color: #333333;
  }
`;

export const VideoPlayer = styled.div`
  height: 580px;
  width: 90%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 8px;
  background-color: black;
  overflow: hidden;
`;
